import type { ReactNode } from 'react';

import { useTranslation } from 'react-i18next';
import { useLocation, useNavigation } from 'react-router';

import { useHeartbeat } from '~/api/application';
import { LoadingScreen } from '~/components';
import { useLeadJourneyClickId } from '~/hooks/useLeadJourneyClickId';
import { routes } from '~/providers/RouterProvider/router.routes';

import { authContentStyle, authLayoutStyle, authLayoutWrapperStyle } from './AuthLayout.css';
import { AuthLayoutFooter } from './AuthLayoutFooter';
import { AuthLayoutHeader } from './AuthLayoutHeader';
import { AuthLayoutSidebar } from './AuthLayoutSidebar';

export const AuthLayout = ({ children }: { children: ReactNode }) => {
  useHeartbeat();
  useLeadJourneyClickId();

  const navigation = useNavigation();
  const location = useLocation();

  const { t } = useTranslation(['common']);

  if (navigation.state === 'loading') {
    return <LoadingScreen>{t('common:loading')}</LoadingScreen>;
  }

  return (
    <div className={authLayoutStyle}>
      <AuthLayoutHeader />

      <div className={authLayoutWrapperStyle}>
        <AuthLayoutSidebar variant={location.pathname === routes.register ? 'kiia' : 'checklist'} />

        <div className={authContentStyle}>
          {children}

          <AuthLayoutFooter />
        </div>
      </div>
    </div>
  );
};
